// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arenaCard {
    width: 320px;
    height: 82px;
    background-size: 100% 100%;
    position: relative;
    display: flex;
    align-items: center;
}

.spectate {
    position: absolute;
    left: 78px;
    bottom: -20px;
    width: 160px;
    padding: 8px 0;
    display: flex;
    justify-content: center;
    background-color: #1c1f25;
    border: 1px solid #244154;
    border-radius: 4px;
}

.spectate:hover {
    background-color: #2e333d;
}

.spectate span {
    font-size: 10px;
    font-weight: 600;
    color: #ffa600;
}

.team_a_members {
    position: absolute;
    left: 24px;
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
    letter-spacing: 1px;
}

.team_a_members span span {
    color: #ffa600;
}

.team_b_members {
    position: absolute;
    right: 24px;
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
    letter-spacing: 1px;
}

.team_b_members span span {
    color: #ffa600;
}

.vsSpan {
    position: absolute;
    left: 150px;
    font-size: 16px;
    font-weight: 600;
    color: #ffa600;
    padding-top: 4px;
}

.team_a_info {
    position: absolute;
    left: 68px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
}

.team_a_info .teamScore {
    font-size: 12px;
    font-weight: 300;
    color: #49d7d8;
}

.team_b_info {
    position: absolute;
    right: 68px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
}

.team_b_info .spactators {
    font-size: 9px;
    font-weight: 300;
    color: #FFFFFF;
}

.team_b_info .spactators span {
    color: #ffa600;
}`, "",{"version":3,"sources":["webpack://./src/components/arenaCard/ArenaCard.style.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,YAAY;IACZ,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".arenaCard {\n    width: 320px;\n    height: 82px;\n    background-size: 100% 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.spectate {\n    position: absolute;\n    left: 78px;\n    bottom: -20px;\n    width: 160px;\n    padding: 8px 0;\n    display: flex;\n    justify-content: center;\n    background-color: #1c1f25;\n    border: 1px solid #244154;\n    border-radius: 4px;\n}\n\n.spectate:hover {\n    background-color: #2e333d;\n}\n\n.spectate span {\n    font-size: 10px;\n    font-weight: 600;\n    color: #ffa600;\n}\n\n.team_a_members {\n    position: absolute;\n    left: 24px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #FFFFFF;\n    letter-spacing: 1px;\n}\n\n.team_a_members span span {\n    color: #ffa600;\n}\n\n.team_b_members {\n    position: absolute;\n    right: 24px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #FFFFFF;\n    letter-spacing: 1px;\n}\n\n.team_b_members span span {\n    color: #ffa600;\n}\n\n.vsSpan {\n    position: absolute;\n    left: 150px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #ffa600;\n    padding-top: 4px;\n}\n\n.team_a_info {\n    position: absolute;\n    left: 68px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #FFFFFF;\n}\n\n.team_a_info .teamScore {\n    font-size: 12px;\n    font-weight: 300;\n    color: #49d7d8;\n}\n\n.team_b_info {\n    position: absolute;\n    right: 68px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 4px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #FFFFFF;\n}\n\n.team_b_info .spactators {\n    font-size: 9px;\n    font-weight: 300;\n    color: #FFFFFF;\n}\n\n.team_b_info .spactators span {\n    color: #ffa600;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
